import { Component, OnInit, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { AuthService } from '../../../shared/authentication/auth.service';
import { AnalyticsHelper } from 'src/app/shared/analytics/analytics-helper';
import { LogHelper } from 'src/app/shared/logging/log-helper';
import { BaseHref } from 'src/app/shared/base-href.helper';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { L10N_LOCALE, L10nTranslationModule } from 'angular-l10n';

const tag = 'Auth';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-user-logged-in',
  templateUrl: './user-logged-in.component.html',
  styleUrls: ['./user-logged-in.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, L10nTranslationModule],
})
export class UserLoggedInComponent implements OnInit {

  public readonly locale = inject(L10N_LOCALE);
  private readonly authService = inject(AuthService);
  private readonly analytics = inject(AnalyticsHelper);

  errorExplanation = signal<string>(null);
  errorDetails = signal<string>(null);

  ngOnInit() {
    this.authService.completeAuthentication(globalThis.location.href).catch((error: Error) => {
      this.analytics.logError(error, 'auth-error');
      LogHelper.debug(tag, 'error in completeAuthentication:', error.message);

      // process the error
      const errorAsString = String(error);
      const isNoMatchingState = errorAsString.includes('No matching state found in storage');
      const isClockSkew = errorAsString.includes('is in the past') || errorAsString.includes('is in the future');
      if (isNoMatchingState) {
        // this is often the result of a bad bookmark (see ROAD-5121), so just navigate to the root URL
        this.navigateToRoot();
      } else if (isClockSkew) {
        // explicit handling for clock skew validation issues
        this.errorExplanation.set(
          'It looks like your computer clock is wrong, which is preventing secure login. Please update your computer clock in your system settings to the current date, time, and time zone.'
        );
        // - this.errorDetails.set(errorAsString); -- don't show error details for this error
      } else {
        // all other errors
        console.error(error);
        this.errorExplanation.set('There was a problem with secure login:');
        this.errorDetails.set(errorAsString);
      }
    });
  }

  navigateToRoot() {
    // ROAD-10802: don't use the router to navigate here
    globalThis.location.href = BaseHref.get();
  }
}
